import * as constants from './constants'

const initialState = {}

export const extending = (state = initialState, action) => {
    switch (action.type) {
        case constants.START_RESERVATION_EXTENSION:
            return {
                ...state,
                reservationId: action.reservationId,
            }
        case constants.EXTENSION_DATE_TIME_RANGE_SET:
            return {
                ...state,
                start: action.start,
                end: action.end,
            }
        case constants.FAILED_RESERVATION_EXTENSION:
            return {
                ...state,
                extendingError: action.extendingError,
            }
        case constants.RESET_EXTENDING_PROGRESS:
            return initialState
        default:
            return state
    }
}
